module.exports = __webpack_public_path__ + "img/brown-carpet-grass-03.6efd0176.png";